export default interface ManagedLayout {
    layoutId: number;
    owner: string;
    name: string;
    layout: string;
    sharedWith: string[];
    isGlobal: boolean;
}

export function removeGlobalsWhenDuplicatedInUser(
    layouts: ManagedLayout[]
): ManagedLayout[] {
    return layouts.filter(
        (l) =>
            !l.isGlobal ||
            (l.isGlobal &&
                !layouts.find((o) => o.name === l.name && !o.isGlobal))
    );
}
